import {ReactComponent as FriendsIcon} from './friends.svg'

function Friends() {
  return <FriendsIcon />
}

export default Friends
